export const getReliefVehicleTypes = () => {
  let vehicleTypes = [
    'Hatchback',
    'RV/SUV',
    'Ute',
    'Van',
    'Other',
  ]

  return vehicleTypes
}
